import React, { memo } from "react";
import { Animated } from "react-native";

import { Box } from "@/components/atoms/Box";
import { TEST_ID_GEMINI_CHAT } from "e2e/testId";

/**
 * Animated styles for a single loading dot
 */
interface AnimatedDotStyles {
  opacity: Animated.AnimatedInterpolation<string | number>;
  transform: { scale: Animated.AnimatedInterpolation<string | number> }[];
}

/**
 * Props for LoadingDotsView
 */
interface LoadingDotsViewProps {
  animatedStyles: {
    dot1: AnimatedDotStyles;
    dot2: AnimatedDotStyles;
    dot3: AnimatedDotStyles;
  };
}

/**
 * View component for animated loading dots indicator
 * @param root0 - Component props
 * @param root0.animatedStyles - Animated style values for each of the three dots (opacity and scale)
 */
const LoadingDotsView: React.FC<LoadingDotsViewProps> = ({
  animatedStyles,
}) => (
  <Box
    {...{
      testID: TEST_ID_GEMINI_CHAT.LOADING_DOTS,
      "data-testid": TEST_ID_GEMINI_CHAT.LOADING_DOTS,
    }}
    className="flex-row items-center justify-center gap-micro"
  >
    {/* SE-6800b: bg-blue-500 -> bg-status-info (worst=50, Δlight=[-46,36,-4],
        Δdark=[-9,50,-2]) — a loading dot maps to the "in-progress" status role. */}
    <Animated.View
      className="size-2 rounded-full bg-status-info"
      // eslint-disable-next-line no-restricted-syntax -- live Animated.AnimatedInterpolation (opacity + scale) on non-atomizable Animated.View
      style={animatedStyles.dot1}
    />
    {/* SE-6800b: bg-blue-500 -> bg-status-info (worst=50, Δlight=[-46,36,-4],
        Δdark=[-9,50,-2]) — a loading dot maps to the "in-progress" status role. */}
    <Animated.View
      className="size-2 rounded-full bg-status-info"
      // eslint-disable-next-line no-restricted-syntax -- live Animated.AnimatedInterpolation (opacity + scale) on non-atomizable Animated.View
      style={animatedStyles.dot2}
    />
    {/* SE-6800b: bg-blue-500 -> bg-status-info (worst=50, Δlight=[-46,36,-4],
        Δdark=[-9,50,-2]) — a loading dot maps to the "in-progress" status role. */}
    <Animated.View
      className="size-2 rounded-full bg-status-info"
      // eslint-disable-next-line no-restricted-syntax -- live Animated.AnimatedInterpolation (opacity + scale) on non-atomizable Animated.View
      style={animatedStyles.dot3}
    />
  </Box>
);

LoadingDotsView.displayName = "LoadingDotsView";
export default memo(LoadingDotsView);
